import {
  Component,
  EventEmitter,
  HostListener,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { navbarData } from "./nav-data";
import {
  animate,
  keyframes,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { INavbarData, fadeInOut } from "./helper";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { BaseServiceService } from "src/app/services/base-service.service";
import { AppData } from "src/app/helpers/app-data";

interface SideNavToggle {
  screenWidth: number;
  collapsed: boolean;
}

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.css"],
  animations: [
    fadeInOut,
    trigger("rotate", [
      transition(":enter", [
        animate(
          "1000ms",
          keyframes([
            style({ transform: "rotate(0deg)", offset: "0" }),
            style({ transform: "rotate(2turn)", offset: "1" }),
          ])
        ),
      ]),
    ]),
  ],
})
export class SidenavComponent implements OnInit, OnDestroy {
  private userPermissionSubscription: Subscription | null = null;

  @Output() onToggleSideNav: EventEmitter<SideNavToggle> = new EventEmitter();
  collapsed = false;
  screenWidth = 0;
  multiple = false;
  navData ;

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 768) {
      this.collapsed = false;
      this.onToggleSideNav.emit({
        collapsed: this.collapsed,
        screenWidth: this.screenWidth,
      });
    }
  }

  constructor(public router: Router, private baseService: BaseServiceService) {}


  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.userPermissionSubscription = this.baseService.currentUserPermissions.subscribe(
      (permissions) => {
        let items = JSON.parse(permissions);
        if (!AppData.ENABLE_CONECTORES) {
          items = this.filterConectoresItems(items);
        }
        this.navData = items;
      }
    );
  }

  private filterConectoresItems(items: any[]): any[] {
    const EXCLUDED_ROUTES = ['conectores', 'tipo-conectores'];
    const result: any[] = [];
    for (const item of items) {
      if (EXCLUDED_ROUTES.includes(item.routeLink)) { continue; }
      if (item.items && item.items.length > 0) {
        const filteredChildren = this.filterConectoresItems(item.items);
        if (filteredChildren.length > 0) {
          result.push({ ...item, items: filteredChildren });
        }
      } else {
        result.push(item);
      }
    }
    return result;
  }



  ngOnDestroy(): void {
    this.userPermissionSubscription.unsubscribe();
  }
  expandSidenav(): void {
    this.collapsed = true;
    this.onToggleSideNav.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  collapseSidenav(): void {
    this.collapsed = false;
    this.onToggleSideNav.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  closeSidenav(): void {
    this.collapsed = false;
    this.onToggleSideNav.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  handleClick(item: INavbarData): void {
    if (!this.multiple) {
      for (let modelItem of this.navData) {
        if (item !== modelItem && modelItem.expanded) {
          modelItem.expanded = false;
        }
      }
    }
    item.expanded = !item.expanded;
  }

  getActiveClass(data: INavbarData): string {
    return this.router.url.includes(data.routeLink) ? "active" : "";
  }
  
  onLogoClick() {
    this.router.navigate(['/home']);
  }
}
